import { render } from "./Menu.vue?vue&type=template&id=ec1e5858&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=ec1e5858&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\Tegra\\abrafarma\\abrafarma-app-ionic-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1e5858"]])

export default __exports__